import { useStaticQuery, graphql } from "gatsby"

const useBoneProductQuery = () => {
  const { allDatoCmsBoneProduct } = useStaticQuery(graphql`
    query BoneProducts {
      allDatoCmsBoneProduct(
        filter: {hideForLocale: {ne: true}}, 
        sort: {position: ASC}
      ) {
        nodes {
          id
          originalId
          title
          brand
          slug
          permalink
          header
          size
          category: boneProductCategories {
            title
          }
          gallery {
            ...InternalAssetProps
          }
        }
      }
    }
  `)
  return allDatoCmsBoneProduct.nodes
}

export default useBoneProductQuery